/**
 * requestConfig
 *
 * @desc 描述：request 配置
 */

/* =================================================== */

import type { AxiosError, RequestConfig, RequestOptions } from '@umijs/max';
import { history } from '@umijs/max';
import { message } from 'antd';
import { set, some } from 'lodash-es';

import { accessTokenStore, clearAccessToken } from '@/store/access-token';
import { getCurrentLocale, getMessage } from '@/utils/i18n';
import type { ResStruct } from './type';

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 设置 token
      if (accessTokenStore.value) {
        set(config, 'headers.Authorization', `Bearer ${accessTokenStore.value}`);
      }

      const locale = getCurrentLocale();
      if (locale) {
        set(config, 'headers.Accept-Language', locale);
      }

      // 设置请求超时时间 (30秒)
      config.timeout = 30000;

      return config;
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    [
      (response) => {
        const config = response.config as RequestOptions;
        const { code } = (response?.data as ResStruct) ?? {};

        // 跳过错误处理
        if (config.skipErrorHandler) {
          return response;
        }

        // 没有登录
        if (code === 401) {
          clearAccessToken();
          // 重定向到登录页
          history.replace('/user/login');
        }

        // 判断业务码状态
        // if (code !== 200) {
        //   const _msg = getHttpMessageByCode(code);

        //   // 是否跳过错误信息
        //   config.skipErrorMeg || message.error(_msg);
        //   return Promise.reject(response);
        // }

        return response;
      },

      (error) => {
        const config: RequestOptions = (error as AxiosError<any>).config;

        // 数组内任意有值都不弹出提示信息
        if (!some([config?.skipErrorHandler, config?.skipErrorMeg])) {
          message.error(getMessage('networkError'));
        }

        return Promise.reject(error);
      },
    ],
  ],
};
